import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneNumber',
    standalone: false
})
export class PhoneNumberPipe implements PipeTransform {

    transform(value: string): string {
        if (!value) {
            return '';
        }

        // Remove todos os caracteres que não sejam números
        let cleaned = ('' + value).replace(/\D/g, '');

        // Verifica o tamanho e aplica o formato correspondente
        let match = cleaned.match(/^(\d{2})(\d{4,5})(\d{4})$/);

        if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
        }

        return value;
    }

}
